export default "__VITE_ASSET__CfczU8Je__"